import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../shared/services/dialog.service';
import { ViewPrescriptionService } from './view-prescriptions.service';
import { InvoiceModel } from '../../models/view-invoices/invoice.model';
import { AppMessages } from '../../shared/constants/messages';
import { AppConstants } from '../../shared/constants/constants';
import { ShareService } from '../../shared/services/share.service';

@Component({
  selector: 'app-view-prescriptions',
  templateUrl: './view-prescriptions.component.html',
  // styleUrls: ['./view-prescriptions.component.css'],
  styleUrls: ['./view-prescriptions.component.css'],
  providers: [ViewPrescriptionService]
})
export class ViewPrescriptionsComponent implements OnInit {

  public viewModel = new ViewPrescriptionViewModel();

  public title: string;
  public appConstants = AppConstants;
  public message: string = '';

  constructor(
    public dialogService: DialogService,
    public vPrescriptionService: ViewPrescriptionService,
    public shareServices: ShareService
  ) {

  }

  ngOnInit() {
    this.title = 'View Prescriptions';
    this.loadData();
  }

  public onEnterSearchPrescription(keyword){
    this.loadData();
  }

  public onFilter(){
    this.loadData();
  }

  public clearKeyword(){
    this.viewModel.keyword = "";
  }

  loadData() {
    var patientId = localStorage.getItem(this.appConstants.activeLink.userId);
    this.vPrescriptionService.getMyPrescriptions(
      patientId,
      this.viewModel.keyword,
      this.viewModel.getOffset(),
      this.viewModel.getLimit()
    ).subscribe(res => {
      if (res) {
        const data = res.json();

        this.viewModel.listItems = [];
        this.viewModel.pagination.totalItems = 0;

        this.viewModel.listItems = data.data;

        if (this.viewModel.listItems && this.viewModel.listItems.length > 0) {
          this.viewModel.pagination.totalPage = data.totalPage;
          this.viewModel.pagination.totalItems = data.totalItems;
        } else {
          this.message = AppMessages.viewPrescription.noPrescription;
        }
      }
    });
  }

  public nextPage() {
    this.viewModel.nextPage();
    this.loadData();
  }

  public getLastPage() {
    this.viewModel.getLastPage();
    this.loadData();
  }

  public selectedPage(index) {
    this.viewModel.selectedPage(index);
    this.loadData();
  }

  public getFirstPage(){
    this.viewModel.getFirstPage();
    this.loadData();
  }

  public previousPage(){
    this.viewModel.previousPage();
    this.loadData();
  }

}

export class ViewPrescriptionViewModel {
  public keyword: string;

  public listItems: any;

  public pagination: any;

  public constructor() {
    this.listItems = [];
    this.keyword = "";
    this.pagination = {
      selectedPage: 1,
      totalItems: 0,
      totalPage: 1,
      limit: 5,
    };
  }

  public getPage() {
    return new Array(this.pagination.totalPage);
  }

  public nextPage() {
    if (this.pagination.selectedPage != this.pagination.totalPage) {
      this.pagination.selectedPage += 1;
    }

  }

  public previousPage() {
    if (this.pagination.selectedPage != 1) {
      this.pagination.selectedPage -= 1;
    }
  }

  public getFirstPage() {
    this.pagination.selectedPage = 1;
  }

  public getLastPage() {
    this.pagination.selectedPage = this.getLastPageIndex();

   
  }

  public getFirstPageIndex(){
    return 1;
  }

  public getLastPageIndex(){
    return this.pagination.totalPage;
  }

  public getOffset() {
    return (this.pagination.selectedPage - 1) * this.pagination.limit;
  }

  public selectedPage(index) {
    this.pagination.selectedPage = index;
    console.log('selected page ' + index);
  }

  public getLimit() {
    return this.pagination.limit;
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-prescriptions/view-prescriptions.component.ts